<template>
  <div class="main-content-container container-fluid px-4">
    <!-- Page Header -->
    <div class="page-header row no-gutters py-4">
      <div class="col-12 col-sm-4 text-center text-sm-left mb-0">
        <span class="text-uppercase page-subtitle">Overview</span>
        <h3 class="page-title">Staff Management</h3>
      </div>
    </div>

    <d-row>
      <d-col
        ><p align="right">
          <d-button outline v-on:click="redirectUser()">Add Staff</d-button>
        </p></d-col
      >
    </d-row>

    <d-modal v-if="showModal" @close="handleClose">
      <d-modal-header>
        <d-modal-title>Staff : {{ lastName }} {{ firstName }}</d-modal-title>
      </d-modal-header>
      <d-modal-body>
        <d-form>
          <d-form-row>
            <!-- First Name -->
            <d-col md="6" class="form-group">
              <label for="feFirstName">First Name</label>
              <d-form-input
                type="text"
                id="feFirstName"
                placeholder="First Name"
                v-model="firstName"
              />
            </d-col>

            <!-- Last Name -->
            <d-col md="6" class="form-group">
              <label for="feLastName">Last Name</label>
              <d-form-input
                type="text"
                id="feLastName"
                placeholder="Last Name"
                v-model="lastName"
              />
            </d-col>
          </d-form-row>

          <div class="form-group">
            <label>Email: </label>
            <d-input
              id="email"
              class="mb-2 mr-sm-2 mb-sm-0"
              placeholder="Email"
              v-model="staffEmail"
            />
          </div>

          <div class="form-group">
            <label>Password: </label>
            <d-input
              id="password"
              class="mb-2 mr-sm-2 mb-sm-0"
              placeholder="Password"
              v-model="password"
            />
          </div>

          <div>
            <label>Role: </label>
            <d-checkbox
              v-model="selected"
              v-for="roles in role"
              :value="roles.id"
              :key="roles.id"
              >{{ roles.roleName }}</d-checkbox
            >
          </div>
          <d-button
            type="submit"
            theme="primary"
            @click.prevent="updateStaff(staffId)"
            >Update</d-button
          >
        </d-form>
      </d-modal-body>
    </d-modal>

    <!-- Default Light Table -->
    <div class="row">
      <div class="col">
        <div class="card card-small mb-4">
          <div class="card-header border-bottom">
            <h6 class="m-0">List of Staff</h6>
          </div>
          <div class="card-body p-0 pb-3 text-center">
            <table class="table mb-0">
              <thead class="bg-light">
                <tr>
                  <th scope="col" class="border-0">User id</th>
                  <th scope="col" class="border-0">Email</th>
                  <th scope="col" class="border-0">Status</th>
                  <th scope="col" class="border-0">Action</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="result in staff" :key="result.id">
                  <td>{{ result.userId }}</td>
                  <td>{{ result.email }}</td>
                        <td>
                          <i v-if="result.suspended" class="material-icons mr-1">highlight_off</i>
                          <i v-else class="material-icons mr-1">check_circle_outline</i>
                        </td>
                  <td>
                    <d-button-group size="small">
                    <d-btn
                      @click.native="handleClick"
                      @click="edit(result.userId, result.email, result.suspended)"><i class="material-icons">edit</i></d-btn
                    >
                    <d-button
                      theme="danger"
                      v-on:click="deleteData(result.userId)"
                      ><i class="material-icons">delete</i></d-button
                    >
                    </d-button-group>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      firstName: "",
      lastName: "",
      password: "",
      staff: [],
      staffId: "",
      staffEmail: "",
      selected: [],
      role: [],
      showModal: false,
    };
  },
  mounted: function () {
    this.loadPage();
  },
  methods: {
    async loadPage() {
      await axios
        .get(
          process.env.VUE_APP_SERVICE_URL+"api/admin/User/Staff"
        )
        .then((response) => {
          this.staff = response.data.result.result;
        })
        .catch(function (error) {
          console.log(error);
        }),
        axios
          .get(
            process.env.VUE_APP_SERVICE_URL+"api/admin/Role"
          )
          .then((response) => {
            this.role = response.data.result;
          })
          .catch(function (error) {
            console.log(error);
          });
    },

    redirectUser() {
      // this method is called on button click
      if (1 == 1) {
        this.$router.push({ name: "create-staff" });
      }
    },
    handleClick() {
      this.showModal = true;
    },
    handleClose() {
      this.showModal = false;
    },
    edit(id, email) {
      this.staffId = id;
      this.staffEmail = email;
      //this.update.push(id);
    },
    async deleteData(id) {
      await axios.delete(
        process.env.VUE_APP_SERVICE_URL+"api/admin/User/" +
          id +
          `/${true}`
      );
      await loadPage();
    },
    updateStaff(id) {
      axios
        .put(
          process.env.VUE_APP_SERVICE_URL+"api/admin/Staff/" + id,
          {
            email: this.staffEmail,
            password: this.password,
            roleIds: this.selected,
          }
        )
        .then((response) => {
          console.log(response.data);
        })
        .catch(function (error) {
          console.log(error);
        });
    },
  },
};
</script>